import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/site-layout.css';

// سال به‌صورت پویا محاسبه می‌شود تا هر سال دستی به‌روزرسانی نشود.
const CURRENT_JALALI_YEAR = new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric' }).format(new Date());
const CURRENT_GREGORIAN_YEAR = new Date().getFullYear();

// لینک‌های پیش‌فرض فوتر — فقط تا زمانی که پاسخ /api/auth/public-settings برسد
// یا اگر پنل ادمین هنوز چیزی برای site_nav.footer ذخیره نکرده باشد استفاده می‌شود.
const DEFAULT_FOOTER_LINKS = [
  { id: 'home', icon: '', image: '', labelFa: 'صفحه اصلی', labelEn: 'Home', href: '/' },
  { id: 'journey', icon: '', image: '', labelFa: 'مراحل بازی', labelEn: 'Game Journey', href: '/about' },
  { id: 'contact', icon: '', image: '', labelFa: 'ارتباط با ما', labelEn: 'Contact Us', href: '/contact' },
  { id: 'login', icon: '', image: '', labelFa: 'ورود به سکوی ۹¾', labelEn: 'Login', href: '/portal-9-3-4' }
];

export default function SiteFooter() {
  const { i18n } = useTranslation();
  const IS_PERSIAN = i18n.language === 'fa';

  const labels = IS_PERSIAN
    ? {
        logo: '⚡ جامعه پاترهدها',
        copy: `© ${CURRENT_JALALI_YEAR} جامعه پاترهدها — تمامی حقوق محفوظ است`,
      }
    : {
        logo: '⚡ Potterheads Community',
        copy: `© ${CURRENT_GREGORIAN_YEAR} Potterheads Community — All Rights Reserved`,
      };

  const [showLogin, setShowLogin] = useState(true);
  const [links, setLinks] = useState(DEFAULT_FOOTER_LINKS);

  useEffect(() => {
    fetch(`/api/auth/public-settings?_=${Date.now()}`)
      .then((r) => r.json())
      .then((data) => {
        if (data?.success && data?.settings) {
          setShowLogin(data.settings.showFooterLoginButton !== false);
        }
        if (Array.isArray(data?.siteNav?.footer) && data.siteNav.footer.length > 0) {
          setLinks(data.siteNav.footer);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <footer className="sftr">
      <div className="sftr__inner">
        <p className="sftr__logo">{labels.logo}</p>
        <p className="sftr__copy">{labels.copy}</p>
        <div className="sftr__links">
          {links.map((link) => {
            // آیتم «ورود» همچنان تابع تنظیم عمومی showFooterLoginButton است.
            if (link.id === 'login' && !showLogin) return null;
            const label = IS_PERSIAN ? link.labelFa : link.labelEn;
            return (
              <a key={link.id} href={link.href} className="sftr__link">
                {link.image && (
                  <img
                    src={link.image}
                    alt=""
                    className="sftr__link-icon"
                    style={link.imageWidth || link.imageHeight ? {
                      width: link.imageWidth ? `${link.imageWidth}px` : undefined,
                      height: link.imageHeight ? `${link.imageHeight}px` : undefined
                    } : undefined}
                  />
                )}
                {!link.image && link.icon && <span className="sftr__link-icon">{link.icon}</span>}
                {label}
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
}
